let apiBase = {
  queryMemberContactList: '/api/show/queryMemberContactList',
  queryAccountInfo: '/api/p/filings/electron/queryAccountInfo',
  startVerify: '/api/p/filings/electron/startVerify',
  queryVerifing: '/api/p/filings/electron/queryVerifing',
  uploadFile: '/api/p/filings/electron/upload',
  getEnterpriseInfo: '/api/p/filings/electron/getEnterpriseInfo',
  verifyEnterpriseInfo: '/api/p/filings/electron/verifyEnterpriseInfo',
  getPersonInfo: '/api/p/filings/electron/getPersonInfo',
  verifyPersonFrontInfo: '/api/p/filings/electron/verifyPersonFrontInfo',
  verifyAccountBackInfo: '/api/p/filings/electron/verifyPersonBackInfo',
  getFaceSessionCode: '/api/p/filings/electron/getFaceSessionCode',
  getFacePrintUrl: '/api/p/filings/electron/getFacePrintUrl',
  getVerifyImage: '/api/p/filings/electron/getVerifyImage',
  verifyFaceLiveness: '/api/p/filings/electron/verifyFaceLiveness',
  submitVerifyImage: '/api/p/filings/electron/submitVerifyImage',
  getVerifyStatus: '/api/p/filings/electron/getVerifyStatus',
  submitVerify: '/api/p/filings/electron/submitVerify',
}
let singleFilingServerObject = null

class FilingServer {
    constructor() {}
    //获取厂商联系list
    queryMemberContactList(params = {}) {
        return $http({
            method: 'get',
            url: apiBase.queryMemberContactList,
            params: params,
        })
    }
    //获取核验主体信息
    queryAccountInfo(data = {}) {
      return $http({
          method: 'post',
          url: apiBase.queryAccountInfo,
          data: data,
      })
    }
    //开始核验
    startVerify(data = {}) {
      return $http({
          method: 'post',
          url: apiBase.startVerify,
          data: data,
      })
    }
    //查询正在校验单流程
    queryVerifing(data = {}) {
      return $http({
          method: 'post',
          url: apiBase.queryVerifing,
          data: data,
      })
    }
    //上传核验文件
    uploadFile(data) {
      return $http({
          method: 'post',
          url: `${apiBase.uploadFile}?uploadType=${data.uploadType}`,
          data: data,
      })
    }
    getEnterpriseInfo(data) {
      return $http({
          method: 'post',
          url: apiBase.getEnterpriseInfo,
          data: data,
      })
    }
    verifyEnterpriseInfo(data) {
      return $http({
          method: 'post',
          url: apiBase.verifyEnterpriseInfo,
          data: data,
      })
    }
    getPersonInfo(data) {
      return $http({
          method: 'post',
          url: apiBase.getPersonInfo,
          data: data,
      })
    }
    verifyPersonFrontInfo(data) {
      return $http({
          method: 'post',
          url: apiBase.verifyPersonFrontInfo,
          data: data,
      })
    }
    verifyAccountBackInfo(data) {
      return $http({
          method: 'post',
          url: apiBase.verifyAccountBackInfo,
          data: data,
      })
    }
    getFaceSessionCode(data) {
      return $http({
          method: 'post',
          url: apiBase.getFaceSessionCode,
          data: data,
      })
    }
    getFacePrintUrl(data) {
      return $http({
          method: 'post',
          url: apiBase.getFacePrintUrl,
          data: data,
      })
    }
    getVerifyImage(data) {
      return $http({
          method: 'post',
          url: apiBase.getVerifyImage,
          data: data,
      })
    }
    verifyFaceLiveness(data) {
      return $http({
          method: 'post',
          url: apiBase.verifyFaceLiveness,
          data: data,
      })
    }
    submitVerifyImage(data) {
      return $http({
          method: 'post',
          url: apiBase.submitVerifyImage,
          data: data,
      })
    }
    getVerifyStatus(data) {
      return $http({
          method: 'post',
          url: apiBase.getVerifyStatus,
          data: data,
      })
    }
    submitVerify(data) {
      return $http({
          method: 'post',
          url: apiBase.submitVerify,
          data: data,
      })
    }
}

function singleFilingServer() {
    if (singleFilingServerObject === null) {
        singleFilingServerObject = new FilingServer()
    }
    return singleFilingServerObject
}

export default singleFilingServer()